$.fn.hasDependentInput = function (dependentElem, opts) {
  var defaultOpts = {
    targetUrl: "",
    requestParamsGenerator: function(){ return {} },
    spinnerContainerTemplate: "<span class=\"col-1\">",
    parentsSelector: ".input",
    errorMessage: "An error occurred fetching the requested data",
    resultFormatter: function( data ){ return data },
    spinnerOpts: {
      /* to accommodate the adjustment made by spinner js,
       * subtract ( radius + width + length )
       * TODO: get position working without this adjustment
       */

      left: -11,
      top: 7,
      length: 4,
      width: 2,
      radius: 5,
    }
  }

  opts = $.extend( defaultOpts, opts )

  var initSpinner = function(){
    var spinner = $( opts.spinnerContainerTemplate )
      .appendTo( $(dependentElem).parents( opts.parentsSelector ) )
    spinner.spin( opts.spinnerOpts )
    return spinner
  }

  var killSpinner = function( spinnerElem ){
    $( spinnerElem ).spin( false ).remove()
    return spinnerElem
  }


  $(this).on( "change", function(){
    var spinner

    $.ajax( opts.targetUrl, {
      data: opts.requestParamsGenerator(),
      dataType: "json",
      beforeSend: function(){ spinner = initSpinner() },
      complete: function(){ killSpinner( spinner ) },
      success: function( data, textStatus, jqXHR ) {
        var formattedData = opts.resultFormatter( data )
        $(dependentElem).val( formattedData ).change()
      },
      error: function(){
        alert( opts.errorMessage )
      }
    } )
  } )

  return this
}
